var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('FileList',{attrs:{"list":_vm.list},on:{"onAdd":_vm.addFiles}}),_c('input',{ref:"fileList",staticClass:"custom-file-input",attrs:{"id":"fileList","accept":'*/*',"multiple":"","type":"file"},on:{"change":function($event){return _vm.uploadNewFiles($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }